/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectFlip } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/effect-flip'
import { Image, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function DoubleRotatePreview({ srcs = [] }) {
  const [validImages, setValidImages] = useState([])
  const [isScrolled, setIsScrolled] = useState(false)
  const swiperRef = useRef(null)
  const scrollerRef = useRef(null)

  useEffect(() => {
    if (Array.isArray(srcs) && srcs.length > 0) {
      const filteredImages = srcs.filter(
        (src) =>
          src.file instanceof Blob ||
          src.file instanceof File ||
          (typeof src.file === 'string' && src.file.startsWith('blob:'))
      )

      setValidImages(
        filteredImages.length === 1
          ? [...filteredImages, ...filteredImages]
          : filteredImages
      )
    } else {
      setValidImages([])
    }
  }, [srcs])

  useEffect(() => {
    const handleScroll = () => {
      if (scrollerRef.current) {
        const { scrollTop } = scrollerRef.current
        if (scrollTop > 15 && !isScrolled) {
          setIsScrolled(true)
          if (swiperRef.current) {
            swiperRef.current.swiper.slideNext()
          }
        } else if (scrollTop <= 15 && isScrolled) {
          setIsScrolled(false)
          if (swiperRef.current) {
            swiperRef.current.swiper.slidePrev()
          }
        }
      }
    }

    const scroller = scrollerRef.current
    if (scroller) {
      scroller.addEventListener('scroll', handleScroll)
    }
    return () => {
      if (scroller) {
        scroller.removeEventListener('scroll', handleScroll)
      }
    }
  }, [isScrolled])

  return (
    <div
      ref={scrollerRef}
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflowY: 'auto', overflowX: 'hidden' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      <Swiper
        ref={swiperRef}
        effect="flip"
        grabCursor
        loop={validImages.length > 1}
        speed={1000}
        modules={[EffectFlip]}
        className="swiper-container position-relative pt-2 pb-3"
      >
        {validImages.map((src, idx) => (
          <SwiperSlide key={idx}>
            <div
              className="flip-card"
              style={{
                width: '240px',
                height: '150px',
                position: 'relative',
              }}
            >
              <Button
                className="position-absolute"
                style={{
                  top: '5px',
                  right: '5px',
                  width: '25px',
                  zIndex: 10,
                  background: 'rgba(0, 0, 0, 0.5)',
                  border: 'none',
                  padding: '0',
                  borderRadius: '50%',
                }}
              >
                ✕
              </Button>
              <img
                className="flip-card-front"
                src={
                  typeof src.file === 'string'
                    ? src.file
                    : URL.createObjectURL(src.file)
                }
                alt={src.label || 'Image'}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <CIIcon />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div style={{ position: 'relative', paddingTop: '1rem' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

DoubleRotatePreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
        PropTypes.string,
      ]),
      label: PropTypes.string,
    })
  ),
}

DoubleRotatePreview.defaultProps = {
  srcs: [],
}

export default DoubleRotatePreview
